
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { Link } from "react-router-dom";

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import { FaEye, FaPlus, FaSignOutAlt } from 'react-icons/fa';
import { formatDate } from '../../utils/utilities';

import './account.css'

export default function Account() {
  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(null);
  const navigation = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('_user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setLoading(false);
    }
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigation('/');
    window.location.reload();
  }

  return (
    <Container>
      <h1 className="d-none">Account</h1>
      {(!loading && user) && (
        <Row className="mb-3">
          <Col className="text-center">
            <img className="account-avatar" src={user.image} alt={user.name} />
            <h2>{user.display_name}</h2>
          </Col>
        </Row>
      )}
      <Row className="justify-content-center mb-3">
        <Col lg="6" className="account-buttons">
          {(!loading && user) && (
            <a 
              href={`https://gnetworkclub.com/member/${user.user_login}`} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-primary w-100"
            ><FaEye /> View Profile</a>
          )}
          {/*
          <Button variant="secondary" className="w-100" onClick={() => alert('to do: show account settings')}><FaPencilAlt /> Account Settings</Button>
          */}
          <Link to="/events/create" className="btn btn-secondary w-100">
            <FaPlus /> Create New Event
          </Link>
          <Button variant="secondary" className="w-100" onClick={handleLogout}><FaSignOutAlt /> Logout</Button>
          {(!loading && user) && (
            <div>
              <p className="mb-0">{user.user_email}</p>
              <p className="mb-0">Joined {formatDate(user.user_registered)}</p>
            </div>
          )}
        </Col>
      </Row>
    </Container>
  );
}
